import "./style.css";

export default function ComoAjudar({ text, contact }) {
  const { address, phone, whatsapp, email, openingHours, website } =
    contact || {};
  const temContato = address || phone || whatsapp || email || website;

  if (!text && !temContato) return null;

  return (
    <section className="nucleo-como-ajudar">
      <h2 className="nucleo-como-ajudar__titulo">Como ajudar</h2>
      {text && <p className="nucleo-como-ajudar__texto">{text}</p>}

      {temContato && (
        <div className="nucleo-como-ajudar__contato">
          {email && (
            <a href={`mailto:${email}`} className="nucleo-como-ajudar__linha">
              {email}
            </a>
          )}
          {phone && (
            <a
              href={`tel:${phone.replace(/\D/g, "")}`}
              className="nucleo-como-ajudar__linha"
            >
              {phone}
            </a>
          )}
          {whatsapp && (
            <a
              href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="nucleo-como-ajudar__linha"
            >
              WhatsApp: {whatsapp}
            </a>
          )}
          {address && (
            <span className="nucleo-como-ajudar__linha nucleo-como-ajudar__linha--texto">
              {address}
            </span>
          )}
          {openingHours && (
            <span className="nucleo-como-ajudar__linha nucleo-como-ajudar__linha--texto">
              {openingHours}
            </span>
          )}
          {website && (
            <a
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="nucleo-como-ajudar__linha"
            >
              Visitar site
            </a>
          )}
        </div>
      )}
    </section>
  );
}
